/**
 * WizardStepHeader — the single header used at the top of every Service-wizard
 * step. Left-aligned, soft rounded icon tile (lucide, not emoji), with the
 * dashboard type scale: a medium/large title and a light, muted subtitle.
 *
 * Usage:
 *   <WizardStepHeader icon={DollarSign} tone="green" title="Pricing & Duration"
 *     subtitle="How does this booking work?" />
 */

const TONES = {
  blue: 'bg-blue-50 text-blue-600',
  green: 'bg-green-50 text-green-600',
  purple: 'bg-purple-50 text-purple-600',
  amber: 'bg-amber-50 text-amber-600',
  rose: 'bg-rose-50 text-rose-600',
  indigo: 'bg-indigo-50 text-indigo-600',
  gray: 'bg-gray-100 text-gray-600',
};

export const WizardStepHeader = ({ icon: Icon, title, subtitle, tone = 'blue' }) => {
  return (
    <div className="flex items-center gap-3 mb-5" data-testid="wizard-step-header" data-step-title={title}>
      {Icon && (
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${TONES[tone] || TONES.blue}`}>
          <Icon className="w-5 h-5" />
        </div>
      )}
      <div className="min-w-0">
        <h3 className="text-lg font-medium text-gray-900 tracking-tight leading-tight">{title}</h3>
        {subtitle && <p className="text-sm text-gray-500 font-light mt-0.5">{subtitle}</p>}
      </div>
    </div>
  );
};

export default WizardStepHeader;
